/*
 * We need to use this one line to get the datalayer variable iwthout eslint freaking out
 * This should not be used for ANYTHING except getting the varaibles created from variables
 * inside of this app. Its extremely unsafe and is completely open to unexpected side effects
 */

// eslint-disable-next-line no-undef
const DATALAYER = dataLayer;

// I've decided i will not be exposing the actual datalayer to the rest of the app
// this service will be forced to be used

export function pushFormSubmission() {
  if (typeof DATALAYER !== "undefined") {
    DATALAYER.push({
      event: "VirtualPageview",
      virtualPageURL: "/thank-you/",
      virtualPageTitle: "Thank you for Registering",
    });
  }
}
